import { Navigation, Scrollbar } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import EFPicture from 'elem/compCommon/EFPicture';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import EcoSpace from 'eco-design/base/eco-space';

export default function M() {
    const { useLang, Link, useRouter } = useGlobal();
    const { t } = useLang('powerbackup');
    const { locale } = useRouter();
    const POSTER_MAP: any = {
        us: [
            'https://websiteoss.ecoflow.com/upload/image/1747814342612/1.jpg',
            'https://websiteoss.ecoflow.com/upload/image/1747814343004/2.jpg',
            'https://websiteoss.ecoflow.com/upload/image/1747814342771/3.jpg',
        ],
        ca: [
            '/responsive/picture/power-backup/13_1.jpg',
            '/responsive/picture/power-backup/13_2.jpg',
            '/responsive/picture/power-backup/13_3.jpg',
            '/responsive/picture/power-backup/13_4.jpg',
        ],
        au: [
            '/responsive/picture/power-backup/13_1_au.jpg',
            '/responsive/picture/power-backup/13_2_au.jpg',
            '/responsive/picture/power-backup/13_3_au.jpg',
            '/responsive/picture/power-backup/13_4_au.jpg',
        ],
    };
    const listsAll: any = [
        {
            img: POSTER_MAP[locale]?.[0],
            desc: t('secM_list1_desc'),
            link: (() => {
                const localeMap: any = {
                    us: 'https://blog.ecoflow.com/us/battery-backup-vs-generator/',
                    ca: 'https://blog.ecoflow.com/ca/best-solar-generators-for-power-blackouts/',
                    au: 'https://blog.ecoflow.com/au/prepare-for-power-outages/',
                };
                return localeMap[locale] || localeMap.us;
            })(),
        },
        {
            img: POSTER_MAP[locale]?.[1],
            desc: t('secM_list2_desc'),
            link: (() => {
                const localeMap: any = {
                    us: 'https://blog.ecoflow.com/us/build-home-battery-backup-system/',
                    ca: 'https://blog.ecoflow.com/ca/best-home-power-battery-backup-solutions/',
                    au: 'https://blog.ecoflow.com/au/best-solar-generators-for-power-blackouts/',
                };
                return localeMap[locale] || localeMap.us;
            })(),
        },
        {
            img: POSTER_MAP[locale]?.[2],
            desc: t('secM_list3_desc'),
            link: (() => {
                const localeMap: any = {
                    us: 'https://blog.ecoflow.com/us/use-home-backup-battery-system-without-solar-power/',
                    ca: 'https://blog.ecoflow.com/ca/what-size-backup-generator-to-power-home/',
                    au: 'https://blog.ecoflow.com/au/common-causes-of-power-outages/',
                };
                return localeMap[locale] || localeMap.us;
            })(),
        },
        {
            img: POSTER_MAP[locale]?.[3],
            desc: t('secM_list4_desc'),
            link: (() => {
                const localeMap: any = {
                    us: '',
                    ca: 'https://blog.ecoflow.com/ca/battery-backup-vs-generator/',
                    au: 'https://blog.ecoflow.com/au/how-to-prepare-for-summer-power-outages/',
                };
                return localeMap[locale] || localeMap.us;
            })(),
        },
        {
            img: POSTER_MAP[locale]?.[4],
            desc: t('secM_list5_desc'),
            link: (() => {
                const localeMap: any = {
                    us: '',
                    au: 'https://blog.ecoflow.com/au/best-home-power-battery-backup-solutions/',
                };
                return localeMap[locale] || localeMap.us;
            })(),
        },
    ];
    let lists = listsAll;
    if (locale == 'ca') {
        lists = listsAll?.slice(0, 4);
    } else if (locale == 'us') {
        lists = listsAll?.slice(0, 3);
    }

    return (
        <div id="power-backup-M" className={`power-backup-M ef-layer ${css['power-backup-M']}`}>
            <EcoSpace />
            <div className="text-box">
                <p className="title">{t('secM_title')}</p>
            </div>
            <Swiper
                className="swiper-box"
                effect="fade"
                modules={[Scrollbar, Navigation]}
                navigation={lists?.length > 3}
                spaceBetween={20}
                slidesPerView={'auto'}
                initialSlide={0}
                scrollbar={{
                    hide: false,
                    draggable: true,
                    dragSize: 32,
                    snapOnRelease: true,
                }}
            >
                {lists?.map((card: any, k: number) => (
                    <SwiperSlide className={`swiper-item item-${k + 1}`} key={k}>
                        <EFPicture className="card-img" src={card?.img} alt={card.desc} />
                        <p className="card-desc">{card?.desc}</p>
                        <Link className="card-link" href={card?.link}>
                            <span className="link-text">{t('common_card_more')}</span>
                            <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="none">
                                <path
                                    d="M6.50006 12.3291L10.5001 8.3291L6.50006 4.3291"
                                    stroke="#2673FF"
                                    strokeWidth="1.33333"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                            </svg>
                        </Link>
                    </SwiperSlide>
                ))}
            </Swiper>
        </div>
    );
}
